import React, { memo } from 'react';
import { Box, Avatar, CircularProgress, Typography } from '@mui/material';
import { SmartToy as BotIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

export const TypingIndicator = memo(() => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 1,
        mb: 2,
        px: 1,
      }}
    >
      <Avatar
        sx={{
          backgroundColor: theme.palette.primary.main,
          width: 36,
          height: 36,
          flexShrink: 0,
          boxShadow: 1,
        }}
      >
        <BotIcon fontSize="small" />
      </Avatar>
      <Box
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderRadius: 3,
          p: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          boxShadow: 2,
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        <CircularProgress size={16} />
        <Typography variant="body2" color="text.secondary">
          LedgerX365 Assistant is typing...
        </Typography>
      </Box>
    </Box>
  );
});

TypingIndicator.displayName = 'TypingIndicator';
